// validationI18nKey.js
'use strict';

export const accountRegister = {
  pass: 'pass',
  usernameInvalidFormat: 'account_hint',
  usernameAlreadyExists: 'already_exists',
  passwordInvalidFormat: 'password_hint',
};
